import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";
import { useAuthContext } from "../contexts/authContext";
import { onError } from "../libs/errorLib";
import Loading from "../components/system/Loading";
import Copyright from "../components/Copyright";

export default function Login() {
  const { userHasAuthenticated } = useAuthContext();

  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordRequired, setNewPasswordRequired] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [cognitoUser, setCognitoUser] = useState(null);
  function validateForm() {
    return email.length > 0 && password.length > 0;
  }

  function validatePasswordForm() {
    return newPassword.length > 0;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);
    try {
      let cu = await Auth.signIn(email, password);
      setCognitoUser(cu);
      if (cu.challengeName === "NEW_PASSWORD_REQUIRED") {
        setNewPasswordRequired(true);
      } else {
        userHasAuthenticated(true);
      }
      setIsLoading(false);
    } catch (e) {
      onError(e);
      setIsLoading(false);
    }
  }

  async function handleNewPasswordSubmit(event) {
    event.preventDefault();
    setIsLoading(true);
    try {
      await Auth.completeNewPassword(cognitoUser, newPassword);
      userHasAuthenticated(true);
    } catch (e) {
      onError(e);
      setIsLoading(false);
    }
  }

  function displayLoginForm() {
    return (
      <main>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="card shadow-lg border-0 rounded-lg mt-5">
                <div className="card-header">
                  <h3 className="text-center font-weight-light my-4">Login</h3>
                </div>
                <div className="card-body">
                  <Form>
                    <div className="form-group">
                      <label className="small mb-1" htmlFor="inputEmailAddress">
                        Email
                      </label>
                      <input
                        className="form-control py-4"
                        id="inputEmailAddress"
                        name="email"
                        type="email"
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter email address"
                      />
                    </div>
                    <div className="form-group">
                      <label className="small mb-1" htmlFor="inputPassword">
                        Password
                      </label>
                      <input
                        className="form-control py-4"
                        id="inputPassword"
                        name="password"
                        type="password"
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter password"
                      />
                    </div>
                    <div className="form-group d-flex align-items-center justify-content-between mt-4 mb-0 mr-1">
                      <Button
                        onClick={handleSubmit}
                        disabled={isLoading || !validateForm()}
                      >
                        Login
                      </Button>
                      <Link to="/forgot-password">Forgot password</Link>
                    </div>
                  </Form>
                </div>
                <div className="card-footer text-center">
                  <Loading isLoading={isLoading} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }

  function displayPasswordForm() {
    return (
      <main>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="card shadow-lg border-0 rounded-lg mt-5">
                <div className="card-header">
                  <h3 className="text-center font-weight-light my-4">
                    Change Password
                  </h3>
                </div>
                <div className="card-body">
                  <Form>
                    <div className="form-group">
                      <label className="small mb-1" htmlFor="inputNewPassword">
                        New Password
                      </label>
                      <input
                        className="form-control py-4"
                        id="inputPassword"
                        name="newPassword"
                        type="password"
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder="Enter new password"
                      />
                    </div>
                    <div className="form-group d-flex align-items-center justify-content-between mt-4 mb-0">
                      <Button
                        onClick={handleNewPasswordSubmit}
                        disabled={isLoading || !validatePasswordForm()}
                      >
                        Change Password
                      </Button>
                    </div>
                  </Form>
                </div>
                <div className="card-footer text-center">
                  <Loading isLoading={isLoading} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }

  return (
    <div id="layoutAuthentication">
      <div id="layoutAuthentication_content">
        {newPasswordRequired ? displayPasswordForm() : displayLoginForm()}
      </div>
      <div id="layoutAuthentication_footer">
        <footer className="py-4 bg-light mt-auto">
          <div className="container-fluid">
            <div className="d-flex align-items-center justify-content-between small">
              <Copyright />
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
